<template>
  <div
    :class="{
      'expandable-product-tile-fi': true,
      'expandable-product-tile-fi--hovered': hovered,
    }"
    @mouseenter="onMouseenter"
    @mouseleave="onMouseleave"
    @click="toggleHover"
  >
    <div class="fi-flex fi-h-full fi-flex-row fi-gap-small sm:fi-gap-large">
      <div>
        <div
          class="expandable-product-tile-fi__image"
          @click="goToProduct"
        >
          <ssr-cloud-image-fi
            v-if="product.image"
            class="expandable-product-tile-fi__img"
            :src="product.image"
            :alt="product.name"
            :aspect-ratio="1"
            :breakpoints="[]"
            :unlimited="120"
            :unlimited-height="120"
            params="func=fit"
            do-not-replace-url
            trim
          />
        </div>
        <div
          v-if="isClosedShop"
          class="expandable-product-tile-fi__price-and-delivery-details"
        >
          <price-savings-fi
            class="expandable-product-tile-fi__price"
            :best-price="currentBestPrice"
            theme="product-list-view"
            hide-savings-in-percent
            stroke-price-absolute
          />

          <div
            v-if="!showWithoutPrice"
            class="expandable-product-tile-fi__vac"
          >
            {{ $dict.get('online-Shop.Product.Vat-excluded') }}
          </div>
        </div>
      </div>

      <div class="fi-flex fi-w-full fi-flex-col">
        <div
          class="expandable-product-tile-fi__artnr"
          @click="goToProduct"
        >
          {{ $dict.get('construction-Projects.Global-Labels.Article-Number', [product.id]) }}
        </div>
        <div class="expandable-product-tile-fi__name-wrapper">
          <div
            class="expandable-product-tile-fi__name"
            @click="goToProduct"
          >
            {{ product.name }}
          </div>
        </div>
        <div class="fi-mt-18 fi-grow"><!-- just a spacer --></div>
        <template v-if="isClosedShop">
          <div
            v-if="!bestPriceLoading"
            class="expandable-product-tile-fi__add-to-cart"
          >
            <button-fi
              :data-productid="product ? product.id : null"
              :data-productname="product ? `${product.id} - ${product.name}` : null"
              :disabled="!bestPrice || isAddingItemToCart[product.id] || outOfStock"
              type="button"
              class="button-fi__primary button-fi--stretched expandable-product-tile-fi__action-button expandable-product-tile-fi__action-button--onlineShop"
              data-test="product-tile-add-to-cart"
              @click.stop.prevent="addProduct"
            >
              <div class="fi-relative fi-pr-[32px]">
                {{ $dict.get('online-Shop.Product-Teaser.Button-Add-To-Cart') }}
                <icon-fi
                  class="fi-absolute fi-right-[-16px] fi-top-[-50%]"
                  icon="shopping-cart"
                />
              </div>
            </button-fi>
          </div>
        </template>
        <button-fi
          v-else-if="isRetailConnectCart && !isSystemPartnerItem"
          :data-productid="product ? product.id : null"
          :data-productname="product ? `${product.id} - ${product.name}` : null"
          :disabled="productInCart || isAddingItemToCart[product.id] || outOfStock"
          data-test="product-tile-add-to-cart"
          type="button"
          class="button-fi__primary button-fi--stretched expandable-product-tile-fi__action-button expandable-product-tile-fi__action-button--retailConnectCart"
          @click.stop.prevent="addProduct"
        >
          {{ $dict.get('online-Shop.Product-Teaser.Button-Add-To-Cart') }}
        </button-fi>

        <button-fi
          v-else-if="href"
          :data-productid="product ? product.id : null"
          :data-productname="product ? `${product.id} - ${product.name}` : null"
          data-test="product-tile-to-cart"
          type="button"
          class="button-fi__primary button-fi--stretched expandable-product-tile-fi__action-button expandable-product-tile-fi__action-button--retailConnect"
          @click.capture.stop.prevent="$emit('go-to-product', 1)"
        >
          {{ $dict.get('online-Shop.Product-Teaser.Button-Product-Text') }}
        </button-fi>
      </div>
    </div>

    <div
      v-if="isMounted && isClosedShop"
      class="hello fi-relative fi-mx-[-38px] fi-bg-brand"
    >
      <div
        class="expandable-product-tile-fi__expander"
        @mouseenter="hoveredExpander = true"
        @mouseleave="hoveredExpander = false"
      >
        <slide-up-down-fi
          :model-value="hovered"
          class="expandable-product-tile-fi__slider"
          duration="300"
        >
          <div
            :class="{
              'expandable-product-tile-fi__action': true,
              'expandable-product-tile-fi__action--hovered': hovered,
            }"
          >
            <template v-if="!isFite">
              <template v-if="isShop">
                <div class="expandable-product-tile-fi__product-facts">
                  <loading-indicator-wrapper
                    class="expandable-product-tile-fi__loading-indicator"
                    :loading="bestPriceLoading || loading"
                    @click.stop.prevent
                  >
                    <div
                      :class="{
                        'expandable-product-tile-fi__details': true,
                        'expandable-product-tile-fi__details--without-price': showWithoutPrice,
                      }"
                    >
                      <div class="expandable-product-tile-fi__quantity-stepper">
                        <quantity-steps-updater
                          v-if="currentBestPrice"
                          ref="quantitySteps"
                          :item="currentBestPrice"
                          :requested-quantity="0"
                          auto-width
                          @update-quantity="$emit('update-best-price', $event)"
                          @quantity-input="$emit('quantity-input', $event)"
                          @value-rounded="onValueRounded"
                        />

                        <div class="fi-flex fi-flex-row fi-justify-between">
                          <div class="expandable-product-tile-fi__availability-status-container">
                            <availability-status
                              v-if="!bestPriceLoading"
                              :class="{ 'fi-mt-9': !currentBestPrice }"
                              :delivery-speed="
                                currentBestPrice ? currentBestPrice.deliverySpeed : 'NODELIVERY'
                              "
                              :stock-levels="currentBestPrice?.stockLevels || null"
                              :is-seefelder="getIsSeefelder(product)"
                              disable-tooltip
                              :article-number="product.id"
                              :requested-quantity="displayedQuantity"
                            />
                          </div>
                          <div>
                            <product-package-size-fi
                              class="expandable-product-tile-fi__base-price"
                              :item="currentBestPrice"
                              align-right
                            />
                          </div>
                        </div>
                        <quantity-modification-hint-fi
                          v-if="quantityIncreasedMessage"
                          class="expandable-product-tile-fi__quantity-modification-hint"
                          :hint="quantityIncreasedMessage"
                          :data-test-2="quantityDataTest2"
                          icon="info"
                          theme="expandable-product-tile-fi"
                        />
                      </div>
                    </div>
                  </loading-indicator-wrapper>
                </div>
              </template>
            </template>
            <template v-else>
              <div class="expandable-product-tile-fi__uvp-price">
                <div
                  v-if="shopifyPrice"
                  class="expandable-product-tile-fi__uvp-price__value"
                  data-test="product-price"
                >
                  <div class="static-product-tile-fi__shopify-price">
                    <div
                      v-if="compareAtPrice"
                      class="expandable-product-tile-fi__compare-price-value"
                    >
                      {{ compareAtPrice }}
                    </div>
                    <div class="expandable-product-tile-fi__shopify-price-value">
                      {{ shopifyPrice }}
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="productPrice"
                  class="expandable-product-tile-fi__uvp-price__value"
                  data-test="product-price"
                >
                  {{ $dict.get('online-Shop.Product.UVP-Price-Prefix') }} {{ productPrice }}
                </div>

                <div class="expandable-product-tile-fi__uvp-price__vat">
                  {{ $dict.get('online-Shop.Product.Vat-included') }}
                </div>
              </div>
            </template>
          </div>
        </slide-up-down-fi>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  AvailabilityStatus,
  ButtonFi,
  IconFi,
  LoadingIndicatorWrapper,
  PriceSavingsFi,
  ProductPackageSizeFi,
  QuantityModificationHintFi,
  SlideUpDownFi,
  SsrCloudImageFi,
} from 'atoms';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref, useTemplateRef, watch } from 'vue';

import QuantityStepsUpdater from '@/components/shop-modules/quantity-steps-updater/QuantityStepsUpdater.vue';
import { useBreakpoints } from '@/composables/breakpoint';
import { useFischer } from '@/composables/fischerPlugin';
import { useSeefelder } from '@/composables/seefelder';
import { useShopifyProduct } from '@/composables/shopifyProduct';
import { useSystemPartner } from '@/composables/systemPartner';
import type { HybrisFischerBestPrice } from '@/generated/graphql';
import { useShopifyStore } from '@/store/pinia/shopify';

import type { TileProduct } from '../ProductTileFi.vue';

defineOptions({
  name: 'ExpandableProductTileFi',
});
const emit = defineEmits<{
  'add-product': [quantity: number];
  'go-to-product': [quantity: number];
  'update-best-price': [quantity: number];
  'quantity-input': [value: void];
}>();

const props = defineProps<{
  product: TileProduct;
  href: string | undefined;
  productInCart: boolean;
  isShop: boolean;
  showWithoutPrice: boolean;
  currentBestPrice: HybrisFischerBestPrice | undefined;
  productPrice: string | null;
  bestPriceLoading: boolean;
  bestPrice: HybrisFischerBestPrice | null | undefined;
  isAddingItemToCart: Record<string, boolean>;
  outOfStock: boolean | undefined;
  loading: boolean;
}>();

const { isLG } = useBreakpoints();
const fischer = useFischer();
const { getIsSeefelder } = useSeefelder();

const quantitySteps = useTemplateRef<typeof QuantityStepsUpdater>('quantitySteps');
const quantityIncreasedMessage = ref<string | null>(null);
const quantityDataTest2 = ref<string | undefined>(undefined);
const hoveredParent = ref(false);
const hoveredExpander = ref(false);
const isMounted = ref(false);

const isClosedShop = fischer.shop.isClosedShop();
const isRetailConnectCart = fischer.shop.isRetailConnectCart();
const { shopifyProducts } = storeToRefs(useShopifyStore());
const { getFormattedPrice, getFormattedCompareAtPrice } = useShopifyProduct(shopifyProducts);
const { isSystemItem } = useSystemPartner();
const isSystemPartnerItem = computed(() => isSystemItem(props.product));

const goToProduct = () => emit('go-to-product', 1);

const hovered = computed<boolean>(() => hoveredParent.value || hoveredExpander.value);

const shopifyPrice = getFormattedPrice(props.product.id);
const compareAtPrice = getFormattedCompareAtPrice(props.product.id);

const onMouseenter = async () => {
  hoveredParent.value = true;
};

const onMouseleave = () => {
  if (isLG.value) {
    hoveredParent.value = false;
  }
};
const toggleHover = () => {
  if (hoveredParent.value) {
    hoveredParent.value = false;
  } else {
    onMouseenter();
  }
};

const breakpointCallback = (value: boolean) => {
  if (value) {
    hoveredParent.value = false;
  } else {
    onMouseenter();
  }
};
watch(isLG, breakpointCallback);
onMounted(() => {
  isMounted.value = true;
  breakpointCallback(isLG.value);
});

const getItemQuantity = () => quantitySteps.value?.getInputValue() || 1;

// The quantity the stepper is actually displaying right now, so the
// availability status queries the same quantity the user sees rather than
// the best price's echoed requestedQuantity (which is 0/null until the
// first best-price response arrives).
const displayedQuantity = computed(
  () =>
    // `||`, not `??`: 0 is QuantityStepsUpdater's "nothing committed yet"
    // sentinel, not a real quantity, so it must fall through too - this
    // mirrors QuantitySteps' own fallback chain for its initial display.
    quantitySteps.value?.internalRequestedQuantity ||
    props.currentBestPrice?.requestedQuantity ||
    props.currentBestPrice?.initialQuantity ||
    undefined,
);

const addProduct = () => {
  emit('add-product', getItemQuantity());
};

const onValueRounded = (hint: string, dataTest2: string) => {
  quantityIncreasedMessage.value = hint;
  quantityDataTest2.value = dataTest2;
};
</script>

<style scoped src="./expandable-product-tile-fi" />
